import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { queryKeys, requestCCApi } from 'src/utils';

import { getCustomErrorMessage } from '../../publication/helper';

export const useSaveBulkReplaceRequest = () => {
  return useMutation({
    mutationFn: saveBulkReplaceRequest,
    onSuccess: () => {
      queryClient.invalidateQueries(
        queryKeys.bulkReplaceRequests.invalidateAll(),
      );
      queryClient.invalidateQueries(
        queryKeys.bulkReplaceRequestNamesByAssemblyIds.invalidateAll(),
      );
      queryClient.invalidateQueries(queryKeys.assemblies.invalidateAll());
      queryClient.invalidateQueries(queryKeys.assemblyListing.invalidateAll());
      queryClient.invalidateQueries(
        queryKeys.assemblyComponents.invalidateAll(),
      );
      queryClient.invalidateQueries(
        queryKeys.viewAssembliesWithComponents.invalidateAll(),
      );
      queryClient.invalidateQueries(queryKeys.assemblies.invalidateAll());
      queryClient.invalidateQueries(queryKeys.assemblyListing.invalidateAll());
    },
  });
};

const saveBulkReplaceRequest = async (bulkReplaceRequestId: number) => {
  const response = await requestCCApi(
    {
      url: `/saveBulkReplaceRequest/${bulkReplaceRequestId}`,
      method: 'PATCH',
    },
    true,
    getCustomErrorMessage,
  );

  return response;
};
